<div class="container">
    <div class="label">
        {{ claimInformation | translate}} {{claimReference}}
    </div>
</div>